const carouselData = [
  {
    title: '2025 年度必看：国产电影崛起',
    desc: '从科幻巨制到现实主义佳作，中国电影正在迎来最好的时代。小草影院精选 2025 年度最值得期待的国产电影，带你一起见证中国电影的崛起之路。',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20epic%20illustration%20with%20warm%20coral%20and%20golden%20tones%2C%20abstract%20grand%20cinematic%20landscape%20with%20dramatic%20clouds%20and%20light%20rays%2C%20clean%20minimal%20composition%2C%20modern%20flat%20illustration%20style%2C%20no%20text%2C%20inspiring%20atmosphere&width=1000&height=500&seq=xiaocao-carousel-1&orientation=landscape',
    tag: '年度专题',
  },
  {
    title: '科幻世界：从地球到星辰大海',
    desc: '探索宇宙奥秘，见证人类文明在银幕上的无限想象。小草影院科幻专区已收录 1800+ 部作品，涵盖硬核科幻、太空歌剧、赛博朋克等多元题材。',
    img: 'https://readdy.ai/api/search-image?query=A%20futuristic%20space-themed%20illustration%20with%20warm%20amber%20and%20deep%20coral%20tones%2C%20abstract%20cosmic%20scene%20with%20planets%20and%20stars%2C%20clean%20minimal%20composition%2C%20modern%20flat%20style%2C%20no%20text%2C%20epic%20cinematic%20mood&width=1000&height=500&seq=xiaocao-carousel-2&orientation=landscape',
    tag: '科幻专区',
  },
  {
    title: '经典港片：永不褪色的银幕记忆',
    desc: '从小马哥的风衣到至尊宝的金箍，港片陪伴了一代人的成长。小草影院经典港片专区收录高清修复版周星驰、成龙、周润发等巨星代表作，重温黄金年代。',
    img: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20retro%20Hong%20Kong%20cinema%20illustration%20with%20warm%20vintage%20amber%20and%20coral%20tones%2C%20abstract%20cityscape%20with%20neon%20glow%2C%20clean%20minimal%20composition%2C%20modern%20flat%20style%2C%20no%20text%2C%20classic%20cinematic%20vibe&width=1000&height=500&seq=xiaocao-carousel-3&orientation=landscape',
    tag: '经典回顾',
  },
  {
    title: '动漫乐园：二次元的无限魅力',
    desc: '从宫崎骏的奇幻世界到新海诚的绝美画面，小草影院动漫专区收录 3200+ 部动画作品。国漫崛起、日漫经典、欧美佳作，献给每一位热爱动画的你。',
    img: 'https://readdy.ai/api/search-image?query=A%20whimsical%20anime-inspired%20illustration%20with%20warm%20coral%20and%20soft%20golden%20tones%2C%20abstract%20dreamy%20landscape%20with%20floating%20elements%2C%20clean%20minimal%20composition%2C%20modern%20flat%20style%2C%20no%20text%2C%20peaceful%20atmosphere&width=1000&height=500&seq=xiaocao-carousel-4&orientation=landscape',
    tag: '动漫专区',
  },
  {
    title: '悬疑之夜：猜不到结局的烧脑之旅',
    desc: '精心挑选的悬疑佳作合集，从国产烧脑到国际名导，每一部都让你屏息凝神直到最后一分钟。准备好接受智力的挑战了吗？',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20thriller%20illustration%20with%20warm%20deep%20coral%20and%20amber%20tones%2C%20abstract%20shadowy%20atmosphere%20with%20dramatic%20lighting%2C%20clean%20minimal%20composition%2C%20modern%20flat%20style%2C%20no%20text%2C%20suspenseful%20mood&width=1000&height=500&seq=xiaocao-carousel-5&orientation=landscape',
    tag: '悬疑精选',
  },
  {
    title: '亲子时光：全家一起看的暖心电影',
    desc: '适合全家老少一起观看的优质影片合集，从动画电影到家庭喜剧，小草影院为你筛选安全、有趣、有意义的亲子观影清单。',
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20family-friendly%20illustration%20with%20soft%20coral%20and%20golden%20tones%2C%20abstract%20cozy%20home%20scene%2C%20clean%20minimal%20composition%2C%20modern%20flat%20style%2C%20no%20text%2C%20heartwarming%20atmosphere&width=1000&height=500&seq=xiaocao-carousel-6&orientation=landscape',
    tag: '亲子专场',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm text-foreground-500 max-w-[560px] mx-auto">精选优质影视专题内容，深度了解电影背后的故事与精彩。</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {carouselData.map((item, i) => (
            <div
              key={i}
              className="group flex flex-col sm:flex-row gap-5 p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-full sm:w-[220px] shrink-0 rounded-lg overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  style={{ minHeight: '140px', aspectRatio: '2/1' }}
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.style.display = 'none';
                  }}
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-center">
                <span className="inline-block px-2 py-0.5 rounded-md text-[10px] font-medium bg-accent-100 text-accent-700 mb-2 self-start">{item.tag}</span>
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}